<script setup lang="ts">
/**
 * @author Giorgi Tseradze, Irakli Kandelaki
 */

//
import { computed, onMounted, onUnmounted, Ref, ref, watch } from "vue";
import { Data } from "../ts/Statistics.interface";
import { useMainStore } from "@/store/main/index";
const props = defineProps<{
  content: Partial<Data>;
}>();

const mainStore = useMainStore();
/** LAZY DATA */
let itemNum = 0;
let stepSize = 1;
let intervalId: NodeJS.Timer;

/** REACTIVE DATA */
const rectTop = ref();
const currentItem = ref();
const stopDisplay = ref(false);
const computedRect = computed(() => rectTop?.value?.top);

/** remove all whitespace characters */
const parsedNonNum = computed(() => {
  if (!props?.content?.nonNum) return;
  return props?.content?.nonNum.replace(/\s+/g, "");
});

/** Increment numbers */
const displayNumbers = (max: number) => {
  stepSize = max / 50;
  intervalId = setInterval(() => {
    if (!max) {
      currentItem.value = 0;
      return;
    }
    if (itemNum + stepSize > max) {
      stepSize = max - itemNum;
    }
    if (itemNum === max) {
      clearInterval(intervalId);
    }
    itemNum += stepSize;
    currentItem.value = Math.ceil(itemNum);
  }, 50);
};

/** start incrementing when card is in vp */
watch(computedRect, (n) => {
  if (n < mainStore?.windowHeight && !stopDisplay.value) {
    if (props?.content?.num === undefined) return;
    stopDisplay.value = true;
    displayNumbers(props?.content?.num);
  }
});
/** watch scroll and measure top position of an element */
onMounted(() => {
  window?.addEventListener("scroll", () => {
    rectTop.value = document
      .querySelector(".statistics__inner-row")
      ?.getBoundingClientRect();
  });
});

onUnmounted(() => {
  clearInterval(intervalId);
});
</script>

<template>
  <div class="statistics__inner-card d-flex dir-col">
    <div v-if="!content?.title">
      <div class="statistics__inner-number">
        <p class="p-16">{{ currentItem }}{{ parsedNonNum }}</p>
      </div>
      <div class="statistics__inner-teaser">
        <p class="p-16">
          {{ content?.teaser }}
        </p>
      </div>
    </div>
    <div class="statistics__inner-title d-flex" v-if="content?.title">
      <p class="p-16">
        {{ content?.title }}
      </p>
    </div>
  </div>
</template>

<style lang="scss"></style>
